// Freshness must be judged on the server's clock (from `hello`), which stamped the
// quotes; a skewed browser clock would read every quote as stale or forever fresh.
import { useEffect, useState } from 'react';

let offsetMs = 0;

export function syncClock(serverNow: string): void {
  const parsed = new Date(serverNow).getTime();
  if (Number.isFinite(parsed)) offsetMs = parsed - Date.now();
}

export function serverNow(): number {
  return Date.now() + offsetMs;
}

/** Wakes this long past a boundary, so a part that turns on the minute has turned when read. */
const PAST_THE_TURN_MS = 50;

/** `aligned` ticks on the server clock's own multiples of `ms`, so a minute turns on the minute. */
export function useNow(ms: number, aligned = false): Date {
  const [now, setNow] = useState(() => new Date(serverNow()));
  useEffect(() => {
    const tick = () => setNow(new Date(serverNow()));
    if (!aligned) {
      const timer = setInterval(tick, ms);
      return () => clearInterval(timer);
    }
    let timer: ReturnType<typeof setTimeout>;
    const wake = () => {
      timer = setTimeout(
        () => {
          tick();
          wake();
        },
        ms - (serverNow() % ms) + PAST_THE_TURN_MS,
      );
    };
    wake();
    return () => clearTimeout(timer);
  }, [ms, aligned]);
  return now;
}
